import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const Bing = React.lazy(() => import('./Bing'));

export default class BingWrapper extends Component {
    render() {
        return(
            <div>
              <Suspense fallback={null}>
                <Bing config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.id)} />
              </Suspense>
            </div>
        );
    }
}

BingWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
